import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-crm',
  version: '1.0.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'getContacts',
      options: [
        { value: 'getContacts', name: 'Get Contacts' },
        { value: 'createContact', name: 'Create Contact' },
        { value: 'updateContact', name: 'Update Contact' },
        { value: 'deleteContact', name: 'Delete Contact' },
      ],
    },
    {
      key: 'contactId',
      label: 'Contact ID',
      type: 'string',
      required: true,
      displayOptions: {
        show: {
          operation: ['updateContact', 'deleteContact'],
        },
      },
    },
    {
      key: 'contactData',
      label: 'Contact Data',
      type: 'json',
      required: true,
      placeholder: '{ "name": "John Doe", "email": "john@example.com" }',
      displayOptions: {
        show: {
          operation: ['createContact', 'updateContact'],
        },
      },
    },
  ],
};

export default schema;
